import React, { Suspense } from 'react';
import lazyLoader from '@utils/lazyLoader';

const OnboardingLazy = lazyLoader(
  () => import('./Onboarding' /* webpackChunkName: "onboarding" */),
);

const Onboarding = () => {
  return (
    <Suspense fallback={null}>
      <OnboardingLazy />
    </Suspense>
  );
};

export default Onboarding;
